/**
 * `/california-consumer-privacy-policy-act/`: a redirect-only page. This URL used to hold a
 * California Consumer Privacy Act page; its copy was replaced by the U.S. State Privacy Disclosure
 * page (`src/pages/us-state-privacy-disclosure/index.tsx`), and this stub keeps the old URL
 * working by sending the browser there. It has no `getStaticProps`, `HeaderLayout` or `MetaHead`.
 *
 * The other client-side redirect stubs are listed in `src/pages/_app.tsx`'s header.
 */
import React from "react";

/** Sets `window.location.href` to `/us-state-privacy-disclosure` after mount; renders nothing. */
export default () => {
	React.useEffect(() => {
		window.location.href = "/us-state-privacy-disclosure";
	}, []);

	return <></>;
};
